import * as Immutable from 'immutable';
import GridStore from './GridStore';
import RulersStore from './RulersStore';
import OverlayStore from './OverlayStore';
import PreviewFabricStore from './PreviewFabricStore';
import RepeatModeStore from './RepeatModeStore';

export interface IToolsStore {
	grid: GridStore,
	rulers: RulersStore
	overlay: OverlayStore
	previewFabric: PreviewFabricStore
	repeatMode: RepeatModeStore
}

const defaultStore = Immutable.Record<IToolsStore>({
	grid: new GridStore,
	rulers: new RulersStore,
	overlay: new OverlayStore,
	previewFabric: new PreviewFabricStore,
	repeatMode: new RepeatModeStore,
});

export default class ToolsStore extends defaultStore implements IToolsStore {}